import jwtDecode from 'jwt-decode';

export default () => {
    const token = sessionStorage.getItem('auth-token');
    const userData = jwtDecode(token);
    
    return {
        token,
        userData
    };
};